export interface ApiError {
  code: string;
  message: string;
  correlationId?: string;
}

export const parseError = (
  response?: { data?: any; statusText?: string },
): ApiError => {
  const data = response?.data ?? {};
  return {
    code: data.code ?? 'UNKNOWN',
    message: data.message ?? response?.statusText ?? 'Unknown error',
    correlationId: data.correlationId,
  };
};

export default parseError;
